import defaultWidgetConfigAggregator from '@corratech/pylot-custom-widgets/defaultConfigAggregator'
import heroSliderWithImagesConfigAggregator from '@corratech/pylot-custom-widgets/HeroSlide/configAggregator'
import heroBannerSlideConfigAggregator from '@corratech/pylot-custom-widgets/HeroSlideItem/configAggregator'
import heroItemConfigAggregator from '@corratech/pylot-custom-widgets/HeroItem/configAggregator'
import heroItemsWrapperConfigAggregator from '@corratech/pylot-custom-widgets/HeroItemsWrapper/configAggregator'
import ookaTogetherConfigAggregator from '@corratech/pylot-custom-widgets/OokaTogether/configAggregator'
import ookaTogetherImageConfigAggregator from '@corratech/pylot-custom-widgets/OokaTogetherImage/configAggregator'
import testimonialConfigAggregator from '@corratech/pylot-custom-widgets/Testimonials/configAggregator'
import testimonialItemConfigAggregator from '@corratech/pylot-custom-widgets/TestimonialsSlide/configAggregator'
import BackgroundConfigAggregator from './BackgroundConfigAggregator'
import faqConfigAggregator from '@corratech/pylot-custom-widgets/FaqWidget/configAggregator'
import traditionConfigAggregator from '@corratech/pylot-custom-widgets/TraditionWidget/configAggregator'
import innovationConfigAggregator from '@corratech/pylot-custom-widgets/AuthenticityAndInnovation/defaultConfigAggregator'
import twoColumnConfigAggregator from '@corratech/pylot-custom-widgets/TwoColumns/twoColumnConfigAggregator'
import imageDisruptorConfigAggregator from '@corratech/pylot-custom-widgets/ImageDisruptor/configAggregator'
import productBannerConfigAggregator from '@corratech/pylot-custom-widgets/Products/configAggregator'
import contentChessConfigAggregator from '@corratech/pylot-custom-widgets/defaultConfigAggregator'
import dynamic from 'next/dynamic'
import HeroGroup from '@corratech/pylot-custom-widgets/HeroSlide/HeroGroup'
import HeroSlides from '@corratech/pylot-custom-widgets/HeroSlideItem/HeroSlides'
import HeroItem from '@corratech/pylot-custom-widgets/HeroItem'
import HeroItemsWrapper from '@corratech/pylot-custom-widgets/HeroItemsWrapper'

export const getAllCustomWidgets = {
    alfakher_shisha_card_group: {
        configAggregator: defaultWidgetConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-custom-widgets/ShishaCardGroup/ShishaCardGroup'
            )
        )
    },
    alfakher_shisha_card: {
        configAggregator: defaultWidgetConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/ShishaCardGroup/ShishaCard')
        )
    },
    alfakher_experience_group: {
        configAggregator: defaultWidgetConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-custom-widgets/ExperienceGroup/ExperienceGroup'
            )
        )
    },
    alfakher_heading: {
        configAggregator: defaultWidgetConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-custom-widgets/AlfakherHeading/AlfakherHeading'
            )
        )
    },
    alfakher_experience_card: {
        configAggregator: defaultWidgetConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-custom-widgets/ExperienceGroup/ExperienceCard'
            )
        )
    },
    alfakher_image_disruptor: {
        configAggregator: imageDisruptorConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/ImageDisruptor')
        )
    },
    faq: {
        configAggregator: faqConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/FaqWidget/FaqWidgetGroup')
        )
    },
    alfakher_taste_of_future_group: {
        configAggregator: defaultWidgetConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-custom-widgets/TasteFuture/TasteFutureGroup'
            )
        )
    },
    alfakher_taste_of_future_item: {
        configAggregator: defaultWidgetConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-custom-widgets/TasteFuture/TasteFutureCard'
            )
        )
    },
    hero_item: {
        configAggregator: heroItemConfigAggregator,
        component: HeroItem
    },
    hero_item_group: {
        configAggregator: heroItemsWrapperConfigAggregator,
        component: HeroItemsWrapper
    },
    alfakher_ooka_together_group: {
        configAggregator: ookaTogetherConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/OokaTogether')
        )
    },
    alfakher_ooka_together_item: {
        configAggregator: ookaTogetherImageConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/OokaTogetherImage')
        )
    },
    testimonial: {
        configAggregator: testimonialConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/Testimonials')
        )
    },
    testimonial_item: {
        configAggregator: testimonialItemConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/TestimonialsSlide')
        )
    },
    alfakher_ooka_better_shared_group: {
        configAggregator: defaultWidgetConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-custom-widgets/OokaBetterShared/OokaBetterSharedGroup'
            )
        )
    },
    alfakher_ooka_better_shared_item: {
        configAggregator: defaultWidgetConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-custom-widgets/OokaBetterShared/OokaBetterSharedItem'
            )
        )
    },
    alfakher_innovative_products_group: {
        configAggregator: BackgroundConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-custom-widgets/AuthenticityAndInnovation/AuthenticityAndInnovation'
            )
        )
    },
    alfakher_innovative_products_item: {
        configAggregator: innovationConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-custom-widgets/AuthenticityAndInnovation/AuthenticityAndInnovationCard'
            )
        )
    },
    alfakher_tradition_group: {
        configAggregator: traditionConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/TraditionWidget')
        )
    },
    alfakher_top_banner: {
        configAggregator: BackgroundConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/PlpBanner/PlpBannerGroup')
        )
    },
    alfakher_two_columns: {
        configAggregator: twoColumnConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/TwoColumns/TwoColumns')
        )
    },
    alfakher_hero_slider: {
        configAggregator: heroSliderWithImagesConfigAggregator,
        component: HeroGroup
    },
    alfakher_hero_slide: {
        configAggregator: heroBannerSlideConfigAggregator,
        component: HeroSlides
    },
    alfakher_discover_ooka_world_group: {
        configAggregator: defaultWidgetConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-custom-widgets/DiscoverBlogContents/DiscoverBlogGroup'
            )
        )
    },
    alfakher_benefits_group: {
        configAggregator: defaultWidgetConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/BenifitBlock/BenefitsGroup')
        )
    },
    alfakher_benefits_item: {
        configAggregator: defaultWidgetConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/BenefitsItem/BenefitsItem')
        )
    },
    alfakher_product_carousel: {
        configAggregator: productBannerConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/Products/products')
        )
    },
    chess_content_group: {
        configAggregator: contentChessConfigAggregator,
        component: dynamic(() =>
            import('@corratech/pylot-custom-widgets/ChessContent')
        )
    }
}
